<template>
  <div class="leave-box">
    <user-header></user-header>
    <user-menu :status='4'></user-menu>
    <div class="leave-main-box">
      <div class="leave">
        <h1>退会手続き</h1>
        <h2 v-if="mode == 1">ご利用、誠にありがとうございました。<br />下のボタンをクリックして頂きますと、<br />退会となります。</h2>
        <h2 v-if="mode == 2">退会手続きが完了しました。<br />ブラウザを閉じてください。</h2>
        <input class="button" type="submit" @click="leave"  v-if="mode == 1" value="退会する">
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'PayFin',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      order_id: this.$route.query.order_id,
      mode: 1,
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    leave () {
      this.$alert('alert', '退会すると、購入履歴等のデータは削除されます。\n退会手続きを完了してもよろしいですか？', this.leave_ok);
    },
    leave_ok () {
      let ld = new this.$loader(this);
      ld._data_set({});
      ld._post_cb_f = this.user_del_cb;
      ld._load_start('/user/user_del.php');
    },
    user_del_cb (data) {
      if (data.res === 1) {
        this.mode = 2;
        this.$store.commit('uLoginInfo/set_data', {token: null});
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.leave-box {
  .leave-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
  }
  .leave {
    position: relative;
    width: 400px;
    margin: 210px auto 10px auto;
    background: #fefefe;
    border: 8px solid #dddddd;
    padding: 38px 75px 42px 75px;
    h1 {
      color: #1b2010;
      font-size: 28px;
      letter-spacing: 2px;
    }
    h2 {
      font-size: 16px;
      font-weight: 100;
      color: #5b5845;
      margin: 34px 0 37px 0;
      a {
        color: #96a68c;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .button {
    margin-top: 25px;
    width: 100%;
    height: 56px;
    color: #fefefe;
    border: initial;
    border-radius: 5px;
    font-size: 16px;
  }

  .fin:after {
    position: absolute;
    bottom: -40px;
    right: -46px;
    display: block;
    width: 88px;
    height: 112px;
    background-image: url('../../assets/flower.svg');
    content: '';
  }

  .new-add {
    a {
      margin-top: 38px;
      color: #96a68c;
      display: block;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media (max-width: 767px) {
    .leave-main-box {
      padding: 20px;
      margin: 0px 0 0 0;
      height: calc(100vh - 90px);
      .leave {
        width: calc(100vw - 110px);
        padding: 18px 15px 22px 15px;
      }
    }
  }
}
</style>
